//////////////////////
import { Chain } from "@rainbow-me/rainbowkit";
import { customChains } from "app/constants";
import { ChainId, NODES_MAP } from "sdk";
import {
  arbitrum,
  base,
  bsc,
  bscTestnet,
  goerli,
  mainnet,
  okc,
  optimism,
  polygon,
  polygonMumbai,
  telos,
  zkSync,
} from "wagmi/chains";

const bscChain: Chain = {
  ...bsc,
  rpcUrls: {
    default: {
      http: [NODES_MAP[ChainId.BINANCE_MAINNET]],
    },
    public: {
      http: [NODES_MAP[ChainId.BINANCE_MAINNET]],
    },
  },
};

const ethChain: Chain = {
  ...mainnet,
  rpcUrls: {
    default: {
      http: [NODES_MAP[ChainId.ETHEREUM_MAINNET]],
    },
    public: {
      http: [NODES_MAP[ChainId.ETHEREUM_MAINNET]],
    },
  },
};

const advancedChains =
  process.env.REACT_APP_ENVIRONMENT === "development" ? [bscTestnet, goerli, polygonMumbai] : [];
export const chains = [
  bscChain,
  arbitrum,
  ethChain,
  polygon,
  okc,
  telos,
  optimism,
  zkSync,
  base,
  ...advancedChains,
  ...customChains,
];
export const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID;
